"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Pagination;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _leftArrow = _interopRequireDefault(require("./leftArrow"));

var _rightArrow = _interopRequireDefault(require("./rightArrow"));

var _navigationButton = _interopRequireDefault(require("./navigationButton"));

var _pageButtons = _interopRequireDefault(require("./pageButtons"));

var _nav = _interopRequireDefault(require("./styled/nav"));

var _paginationContainer = _interopRequireDefault(require("./styled/paginationContainer"));
/**
 * @category Layout
 */


function Pagination(props) {
  var pages = props.pages,
      activePage = props.activePage,
      onChange = props.onChange,
      className = props.className,
      style = props.style;
  var isFirstItemSelected = activePage === 1;
  var isLastItemSelected = activePage === pages;
  return _react["default"].createElement(_nav["default"], {
    className: className,
    "aria-label": "pagination",
    style: style
  }, _react["default"].createElement(_paginationContainer["default"], null, _react["default"].createElement(_navigationButton["default"], {
    dataId: "previous-page-button",
    icon: _react["default"].createElement(_leftArrow["default"], null),
    onClick: function onClick(event) {
      return onChange(event, activePage - 1);
    },
    disabled: isFirstItemSelected,
    ariaLabel: "Goto Previous Page"
  }), _react["default"].createElement(_pageButtons["default"], {
    onChange: onChange,
    pages: pages,
    activePage: activePage
  }), _react["default"].createElement(_navigationButton["default"], {
    dataId: "next-page-button",
    icon: _react["default"].createElement(_rightArrow["default"], null),
    onClick: function onClick(event) {
      return onChange(event, activePage + 1);
    },
    disabled: isLastItemSelected,
    ariaLabel: "Goto Next Page"
  })));
}

Pagination.propTypes = {
  /** The total number of pages. e.g. if your collection has 120 items and the page
  size is 50 then pages={Math.ceil(120/50)}/pages={3} */
  pages: _propTypes["default"].number.isRequired,

  /** The number of the page that is selected. */
  activePage: _propTypes["default"].number,

  /** The action triggered when page button is clicked. */
  onChange: _propTypes["default"].func,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
Pagination.defaultProps = {
  activePage: undefined,
  onChange: function onChange() {},
  className: undefined,
  style: undefined
};